import { useMutation } from "react-query";
import { endpoints } from "utils/endpoints";
import http from "utils/http";

const addSubmitSubscribe = (postData) => {
  return http().post(endpoints.forms.submitSubscribe, postData);
};

export function useSubmitSubscribe() {
  return useMutation(addSubmitSubscribe, {
    onError: (errorData) => {
      const errorMessage = errorData?.error?.message || errorData?.message;
      alert(errorMessage);
    },
  });
}
